module.exports = __webpack_public_path__ + "static/media/rig.647d7d55.jpg";